module.exports = __webpack_public_path__ + "img/ic_32_exercises_fullbody.cdba013a.svg";